import styled from "styled-components";

export const ExpandedRankContentStyled = styled.div`
  .expanded_label {
    background: ${({ theme }) => theme.COLORS.BLUE_26};
    padding: 12px 16px;
    font-family: ${({ theme }) => theme.FONT.STYLE.REGULAR};
    font-size: ${({ theme }) => theme.FONT.SIZE.S14};
    color: ${({ theme }) => theme.COLORS.GRAY_23};
  }

  .sub_rows_container {
    border: 1px solid ${({ theme }) => theme.COLORS.GRAY_22};
    border-top: none;
  }

  .sub_row {
    display: grid;
    align-items: center;
    padding: 4px 20px;
    min-height: 40px;
    border-bottom: 1px solid ${({ theme }) => theme.COLORS.BLUE_26};
    font-size: ${({ theme }) => theme.FONT.SIZE.S14};

    &:last-child {
      border-bottom: none;
    }
  }

  .sub_row_department {
    grid-template-columns: 0.4fr 1.15fr 1.35fr 1fr 0.85fr;
  }

  .sub_row_team {
    grid-template-columns: 0.2fr 0.6fr 0.45fr 0.5fr 0.7fr ;
  }

  .sub_rank {
    font-family: ${({ theme }) => theme.FONT.STYLE.REGULAR};
    font-size: ${({ theme }) => theme.FONT.SIZE.S14};
    color: ${({ theme }) => theme.COLORS.GRAY_23};
  }

  .sub_name_purple {
    font-family: ${({ theme }) => theme.FONT.STYLE.MEDIUM};
    color: ${({ theme }) => theme.COLORS.PURPLE_1};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .sub_company_semibold {
    font-family: ${({ theme }) => theme.FONT.STYLE.SEMIBOLD};
    color: ${({ theme }) => theme.COLORS.PURPLE_1};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    padding-left: 8px;
    padding-right: 8px;
  }

  .sub_dept_regular {
    font-family: ${({ theme }) => theme.FONT.STYLE.REGULAR};
    color: ${({ theme }) => theme.COLORS.GRAY_23};
  }

  .sub_empty {
    padding: 24px 0;
    text-align: center;
    font-family: ${({ theme }) => theme.FONT.STYLE.REGULAR};
    font-size: ${({ theme }) => theme.FONT.SIZE.S14};
    color: ${({ theme }) => theme.COLORS.GRAY_23};
  }

  .sub_action {
    font-family: ${({ theme }) => theme.FONT.STYLE.SEMIBOLD};
    font-size: ${({ theme }) => theme.FONT.SIZE.S14};
    color: ${({ theme }) => theme.COLORS.GRAY_23};
    text-decoration: underline;
    cursor: pointer;
    background: none;
    border: none;
    padding: 0;
  }
`;
